import { View } from 'foundations-components/transitional/components/View';
import { LowLevelAuthErrorAlert } from '../LowLevelAuthErrorAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export function AuthErrorSection({
  appName,
  authError,
  errorContext,
  processError
}) {
  if (!authError) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "600",
    as: "div",
    children: /*#__PURE__*/_jsx(LowLevelAuthErrorAlert, {
      appName: appName,
      error: authError,
      context: errorContext,
      processError: processError
    })
  });
}